import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, Subject } from 'rxjs';
import { PageableApiResponse } from '../../models/core-models';
import { CreatedConfigurationData } from '../url-address-config/url-address-config.types';
import { ApiDomainsResponse, CampaignsConfigurations, PPIResponseData } from './ppi.service.types';

@Injectable({
  providedIn: 'root'
})
export class PpiService {
  public activeCampaignsWithConfigurations = new Subject<CampaignsConfigurations>();
  public addPromotionMethod = new Subject<boolean>();
  public directLinkAddedOrEdited = new Subject<CreatedConfigurationData & Record<string, any>>();
  public isPromotionPending = false;

  constructor(private http: HttpClient) {}

  public getPPIapi(): Observable<PageableApiResponse<ApiDomainsResponse>> {
    return this.http.get<PageableApiResponse<ApiDomainsResponse>>(environment.apiUrl + `/ppi/api_domains`);
  }

  public getPPIDirectLinksList(): Observable<PageableApiResponse<PPIResponseData>> {
    return this.http.get<PageableApiResponse<PPIResponseData>>(environment.apiUrl + '/ppi/configuration/list');
  }
}
